import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import IsLoading from "../../../IsLoading";
import "./home.css"

// IMPORTING COMPONENTS_______________________
import Header from "./home-comps/Header";
import Hero from "./home-comps/Hero";
import GalleryS from "./home-comps/GalleryS";
import OurServices from "./home-comps/OurServices";
import HomeHeading from "./home-comps/HomeHeading";
import HomeComp6 from "./home-comps/HomeComp6";
import Organize from "./home-comps/Organize";
import Future from "./home-comps/Future";
import Footer from "./home-comps/Footer";
import PricingCTA from "../public-routs-comps/home-comps/PrincingCTA";
import DiscrCardB from "./home-comps/DiscrCardB";
import HomeDiscrA from "./home-comps/HomeDiscrA";
import HomeLinkCTA from "./home-comps/HomeLinkCTA";
import HomeTransformCTA from "./home-comps/HomeTransformCTA";
import HomeBlog from "./home-comps/HomeBlog";
import ZPattern from "./home-comps/ZPattern";
import UniverseGallery from "./home-comps/UniverseGallery";
import UniverseCTA from "./home-comps/UniverseCTA";
import GlobalCommerceGlobe from "./home-comps/GlobalCommerceGlobe";
import MobileNavigation from "./home-comps/MobileNavigation";
import MobileHero from "./home-comps/MobileHero";
import FeatureTrailer from "./home-comps/FeatureTrailer";

export default function Home() {
  const [loading, setLoading] = useState(true);
  const [showStickyNav, setShowStickyNav] = useState(false);

  const clientData = useSelector((state) => state.clientFunction?.companyData);

  const isAuthenticated = useSelector(
    (state) => state.clientFunction?.isAuthenticated,
  );

  const { t, i18n } = useTranslation();

  useEffect(() => {
    setLoading(false);
    const handleScroll = () => {
      setShowStickyNav(window.scrollY > 320); // adjust value
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      {loading ? (
        <IsLoading></IsLoading>
      ) : (
       <section className="sectionHomeCont fx-cl">

  {/* Desktop Header */}
  <div className="desktopHomeHeader">
    <Header setLoading={setLoading} showMobile={false} />

    <Header
      setLoading={setLoading}
      sticky={true}
      showStickyNav={showStickyNav}
      showMobile={false}
    />
  </div>

  {/* Mobile Header */}
  {/* <div className="mobileHomeHeader">
    <MobileNavigation
      setLoading={setLoading}
    />
  </div> */}

  <Hero />
  <MobileHero />
  
  <HomeHeading />
  <Organize />
  <HomeDiscrA />
  <ZPattern />
  <HomeTransformCTA />
  <GlobalCommerceGlobe />
  <UniverseCTA />
  <PricingCTA />
  <HomeLinkCTA />
  <UniverseGallery />
  <FeatureTrailer />
  {/* <Future /> */}
  <Footer />

</section>
      )}
    </>
  );
}
